import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMagentoComponent } from './simple-icons-magento.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMagentoComponent ],
    exports:      [ SimpleIconsMagentoComponent ],
    bootstrap:    []
})
export class SimpleIconsMagentoModule {}
